import { render } from "./BaseTable.vue?vue&type=template&id=248a19fd"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jermainekelly/Developer/Client_Work/BrandedMind/Clients/Telidesk/telidesk-telinta-log-viewer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__